import { render, staticRenderFns } from "./RegistroPublicoView.vue?vue&type=template&id=3efd3668&"
import script from "./RegistroPublicoView.vue?vue&type=script&lang=ts&"
export * from "./RegistroPublicoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports